import { create } from 'zustand';
import { toast } from 'react-toastify';
import {
  getCartApi, addToCartApi, updateCartItemApi,
  removeCartItemApi, clearCartApi,
} from '../api/cart.api';
import useAuthStore from './authStore';

// Simple callback ref so cartStore can trigger the login modal without React context
let _openLoginModal = null;
export const registerLoginModalTrigger = (fn) => { _openLoginModal = fn; };

const useCartStore = create((set, get) => ({
  cart: null,
  loading: false,

  fetchCart: async () => {
    try {
      set({ loading: true });
      const res = await getCartApi();
      set({ cart: res.data.data });
    } catch {
      // silently fail if not logged in
    } finally {
      set({ loading: false });
    }
  },

  addItem: async (productId, quantity = 1, variantId = null) => {
    const { isAuthenticated } = useAuthStore.getState();
    if (!isAuthenticated) {
      _openLoginModal?.();
      return;
    }
    try {
      const res = await addToCartApi({ productId, quantity, variantId });
      set({ cart: res.data.data });
      toast.success('Added to cart');
    } catch (err) {
      toast.error(err?.response?.data?.message || 'Failed to add to cart');
    }
  },

  updateItem: async (itemId, quantity) => {
    try {
      const res = await updateCartItemApi(itemId, quantity);
      set({ cart: res.data.data });
    } catch (err) {
      toast.error(err?.response?.data?.message || 'Failed to update cart');
    }
  },

  removeItem: async (itemId) => {
    try {
      const res = await removeCartItemApi(itemId);
      set({ cart: res.data.data });
      toast.success('Item removed');
    } catch {
      toast.error('Failed to remove item');
    }
  },

  clearCart: async () => {
    try {
      await clearCartApi();
      set({ cart: null });
    } catch {
      // ignore
    }
  },

  // Computed helpers
  get itemCount() {
    return get().cart?.items?.reduce((s, i) => s + i.quantity, 0) ?? 0;
  },
  get subtotal() {
    return get().cart?.items?.reduce((s, i) => s + i.price * i.quantity, 0) ?? 0;
  },
}));

export default useCartStore;
